import { Row } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledWelcomeModal = styled.div`
  div label {
    font-weight: 600;
    font-size: 1.4rem;
  }
  .modal-body {
    font-size: 1.4rem;
    word-break: break-word;
    hyphens: auto;
  }

  h2 {
    font-size: 2.3rem;
    font-weight: 600;
  }
  h3 {
    font-size: 1.6rem;
  }
  h4 {
    font-size: 1.4rem;
  }
  ul {
    margin-left: 3rem;
    li {
      font-size: 1.4rem;
    }
  }
`

export const StyledRow = styled(Row)`
  display: flex;
  justify-content: space-between;
  margin-left: 1rem;
  margin-right: 3rem;
  margin-top: 2rem;

  .custom-control-input ~ .custom-control-label::before {
    border: 1px solid #ced4da !important;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor} !important;
  }

  .custom-control-input:focus ~ .custom-control-label::before {
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor} !important;
  }

  input[type='checkbox'] {
    border: 1px solid #ced4da !important;

    &:checked {
      background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor} !important;
    }

    &:focus {
      border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor} !important;
    }
  }
`
